import { useProfessionalData } from '~/modules/professional/hook/use-professional-data';
import { useTracker } from '@archipro-website/tracker';
import {
    parsePhoneNumberFromString,
    type CountryCode,
} from 'libphonenumber-js';
import { useRootData } from '~/modules/root';

export const usePhoneTracking = () => {
    const professionalData = useProfessionalData();
    const tracker = useTracker();

    const { localisation } = useRootData();

    const userCountry = localisation.country;
    const professionalCountry =
        professionalData?.professional?.Country ?? undefined;

    const phone =
        professionalData?.professional?.PhoneTracking && professionalCountry
            ? parsePhoneNumberFromString(
                  professionalData.professional.PhoneTracking,
                  professionalCountry as CountryCode
              )
            : null;

    // For local phone numbers show them in a nice pretty local format
    const phoneLabel = phone
        ? professionalCountry === userCountry
            ? phone.formatNational()
            : phone.formatInternational()
        : null;

    const handlePhoneClick = () => {
        if (phone) {
            tracker.log(`PhoneSubmit`, {
                url: new URL(window.location.href),
                label: phone.number,
            });

            // calls the number
            window.location.href = `tel:${phone.number}`;
        }
    };

    // Disable phone tracking for now
    const disablePhoneTracking = true;

    return {
        enabled: !!phone && !disablePhoneTracking,
        phone,
        phoneLabel,
        handlePhoneClick,
    };
};
